// src/components/Login.js
import { generateCodeVerifier, generateCodeChallenge } from '../pkce';

const CLIENT_ID = '88fa6fcca1ed4bba89426b4c04e13d1e';
const REDIRECT_URI = 'https://spotify.az3.infogenixdev.com';

const scopes = [
  'user-read-private',
  'user-read-email',
  'user-library-read',
  'user-follow-read',
  'user-read-playback-state',
  'user-modify-playback-state',
  'user-read-currently-playing',
  'playlist-read-private',
  'playlist-read-collaborative',
  'streaming',
  'app-remote-control'
];

const handleLogin = async () => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  // Store the code verifier for later use during token exchange
  window.localStorage.setItem('code_verifier', codeVerifier);

  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    response_type: 'code',
    redirect_uri: REDIRECT_URI,
    scope: scopes.join(' '),
    code_challenge_method: 'S256',
    code_challenge: codeChallenge,
  });

  window.location.href = `https://accounts.spotify.com/authorize?${params.toString()}`;
};

const Login = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="text-center">
        <h1 className="mb-4">Welcome to Custom Spotify Player</h1>
        <button className="btn btn-success btn-lg" onClick={handleLogin}>
          Login with Spotify
        </button>
      </div>
    </div>
  );
};

export { CLIENT_ID, REDIRECT_URI };
export default Login;
